export class AppConstants {
  public static ROLE_MAPPING = {
    'Organizational Admin': 'org_admin',
    'Location Admin': 'loc_admin',
    Technician: 'tech',
    Teacher: 'teacher',
  };
  public static INVERSE_ROLE_MAPPING = {
    org_admin: 'Organizational Admin',
    loc_admin: 'Location Admin',
    tech: 'Technician',
    teacher: 'Teacher',
  };
}
export const DEPENDENCIES_URL_REGEX = `^((https|http)://)?(www\\.)?(?!www\\.)([*.])?[-a-zA-Z0-9@:%._+~#=]{1,256}\\.[a-zA-Z0-9()]{1,63}\\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)`;
export const ALLOW_BLOCK_URL_REGEX = `^((https|http)://)?(www\\.)?(?!www\\.)[-a-zA-Z0-9@:%._+~#=]{1,256}\\.[a-zA-Z0-9()]{1,63}\\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)`;
// export const ALLOW_BLOCK_URL_REGEX=/^(((http|https|ftp):\/\/|)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?)$/;

export const CSV_URL_FILE_SIZE_LIMIT = 2.5e7;

export const WHITESPACES_REGEX = /^(\s+\S+\s*)*(?!\s).*$/;

export const MAX_CODE_LENGTH = 8;
export const MAX_NICKNAME_LENGTH = 18;

//Format to string in yyyy-mm-dd
export function formatDateToString(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'PP',
    monthYearLabel: 'yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'yyyy',
  },
};
